import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Autocomplete from '@material-ui/lab/Autocomplete';

//import { ProjectSelect } from '../components/ProjectSelect';
//import { MissionSelect } from '../components/MissionSelect';

import { RomReview } from "../components/RomReview";
import { RomData } from "../components/RomData";

//import { postRequest, getRequest, URL } from "../api/helper";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { DashboardRomTemplates } from '../components/DashboardRomTemplates';

import 'moment-timezone';
import moment from 'moment'

import CircularProgress from '@material-ui/core/CircularProgress';

import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';

export class MissionDetailsPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            typeOfROM: "",
            reasonfortheRomReview: "",
            fieldPhaseStartDate: new Date(),
            fieldPhaseEndDate: new Date(),
            missionMonitor: null,
            missionQualityController: null,
            missionQualityAssurance: null,
            stakeholderName: "",
            stakeholderSurname: "",
            stakeholderCompany: "",
            stakeholderEmail: "",
            stakeholders: [],
            projects: [],
            missions: [],
            users: [],
            monuserid: 0,
            qcuserid: 0,
            qauserid: 0,
            missionDetails: {},
            mrFile: null,
            mqFile: null,
            nsFile: null,
            nwFile: null,
            mrFileName: null,
            mqFileName: null,
            nsFileName: null,
            nwFileName: null,
            userType: -1,
            userRole: -1,
            isFetching: true,
            isLoadingFinished: false,
            monQualityCheckList: null,
            qcQualityCheckList: null,
            schedulePlan: null,
            selectedcomponentprojectid: -1,
            modalResetOpen: false,
            modalChangeProject: false,
        };
    }

    async componentDidMount() {

        let pageTokenAuthData = {
            operation: "AuthCheckToken"
        };

        await fetch(global.variables.API_CHECKTOKEN, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageTokenAuthData)
        })
            .then(response => response.json())
            .then(result => {
                if (result.resultstate > 0 ||
                    result.authresp === 2) {
                    window.location.href = "/login";
                }
            }).catch(() => {
                window.location.href = "/login";
            });

        //const projects = [
        //    { title: 'Project 1', no: 1 },
        //    { title: 'Project 2', no: 2 },
        //    { title: 'Project 3', no: 3 },
        //    { title: 'Project 4', no: 4 },
        //    { title: 'Project 5', no: 5 }
        //];
        //const beneficiaries = [
        //    { name: "Emre", surName: "Yılmaz", company: "Kuartek", eMail: "emre@kuartekdigital.com" },
        //    { name: "Çağlar ", surName: "İspirli", company: "Siu", eMail: "caglarispirli@gmail.com" }
        //]

        //await this.setState({
        //    //projects: projects,
        //    beneficiaries
        //});

        //await fetch("/api/AssignMission/LoadPageJSON", {
        //    method: "POST",
        //    headers: {
        //        Authorization: "Bearer " + localStorage.getItem("authtoken"),
        //        Accept: "application/json",
        //        "Content-Type": "application/json"
        //    },
        //    body: JSON.stringify(this.state)
        //})
        //    .then(response => response.json())
        //    .then(result => {
        //        console.log(result);
        //    });

        //await this.loadPageProjects();
        //await this.loadPageMissions();

        await this.setState({
            missionId: this.props.match.params.id,
            selectedmissionid: this.props.match.params.id
        });

        await this.loadPageUsers();
        await this.loadPageMONQCQADetails();
        await this.loadPageStakeholders();
        await this.loadPageTemplateButtons();
        await this.loadPageProjects();
        await this.getUserType();
        await this.getUserRole();

        await this.setState({ isFetching: false });
        await this.setState({ isLoadingFinished: true });
    }

    handleChange = (e) => {
        e.persist();
        this.setState({ [e.target.name]: e.target.value });
    }

    handleChangeDate = (name, value) => {
        console.log(name);
        console.log(value);

        //this.setState({ [name]: new Date(value) });
        this.setState({ [name]: new Date(moment(value).format('YYYY-MM-DD')) });
    };

    handleSelectChange = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    //handleProjectSelectChange = async (e, v) => {
    //    e.persist();

    //    //console.log(e.target.idProjectDetails);

    //    if (v !== undefined & v !== null) {
    //        //if (v !== null) {
    //        //await this.setState({ selectedprojectid: v.idProjectDetails });
    //        await this.setState({ selectedmissionid: v.idMissionDetails });
    //        //    //console.log(" :: " + e.target.name + " " + e.target.value + " " + v.idProjectDetails + " " + e.target.textContent);

    //        //    //for (var propertyKey in v) {
    //        //    //    console.log(v + " " + propertyKey + " " + v[propertyKey]);
    //        //    //}

    //        //await this.loadPageBeneficiaries();
    //        //await this.loadPageMONQC();

    //        await this.loadPageMissions();
    //    } else {
    //        await this.setState({
    //            selectedmissionid: -1,
    //            stakeholders: [],
    //            projectMonitor: null,
    //            projectQualityController: null,
    //            projectQualityAssurance: null
    //        });
    //    }
    //}

    //handleMissionSelectChange = async (e, v) => {
    //    e.persist();

    //    //console.log(e.target.idProjectDetails);

    //    if (v !== undefined & v !== null) {
    //        //if (v !== null) {
    //        await this.setState({ selectedmissionid: v.idMissionDetails });
    //        //    //console.log(" :: " + e.target.name + " " + e.target.value + " " + v.idProjectDetails + " " + e.target.textContent);

    //        //    //for (var propertyKey in v) {
    //        //    //    console.log(v + " " + propertyKey + " " + v[propertyKey]);
    //        //    //}

    //        await this.loadPageStakeholders();
    //        await this.loadPageMONQCQA();
    //    } else {
    //        await this.setState({
    //            selectedmissionid: -1,
    //            stakeholders: [],
    //            missionMonitor: null,
    //            missionQualityController: null,
    //            missionQualityAssurance: null
    //        });
    //    }
    //}

    handleMONUserChange = (e, v) => {
        e.persist();
        if (v !== undefined & v !== null) {
            this.setState({
                monuserid: v.idLoginCredentials,
                missionMonitor: v
            });
        } else {
            this.setState({
                monuserid: -1,
                missionMonitor: null
            });
        }
    }

    handleQCUserChange = (e, v) => {
        e.persist();
        if (v !== undefined & v !== null) {
            this.setState({
                qcuserid: v.idLoginCredentials,
                missionQualityController: v
            });
        } else {
            this.setState({
                qcuserid: -1,
                missionQualityController: null
            });
        }
    }

    handleQAUserChange = (e, v) => {
        e.persist();
        if (v !== undefined & v !== null) {
            this.setState({
                qauserid: v.idLoginCredentials,
                missionQualityAssurance: v
            });
        } else {
            this.setState({
                qauserid: -1,
                missionQualityAssurance: null
            });
        }
    }

    //handleSaveOnClick = () => {
    //    console.log(this.state);

    //    //fetch(global.variables.API_ASSIGNMISSION_USERS, {
    //    //    method: "POST",
    //    //    headers: {
    //    //        Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //    //        Accept: "application/json",
    //    //        "Content-Type": "application/json"
    //    //    },
    //    //    body: JSON.stringify(this.state)
    //    //})
    //    //    .then(response => response.json())
    //    //    .then(result => {
    //    //        console.log(result);
    //    //    });
    //}

    handleAddStakeholdersOnClick = async () => {
        console.log(this.state);

        await this.setState({ isFetching: true });

        await fetch(global.variables.API_ASSIGNMISSION_STAKEHOLDERS_ADD, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else if (result.resultstate === 2) {
                    toast.warn("Not Authorized!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadPageStakeholders();
            });

        await this.setState({ isFetching: false });
    }

    handleRemoveStakeholdersOnClick = async (id) => {

        //e.persist();
        await this.setState({ isFetching: true });

        //var removeObject = { removeStakeholdersId: e.currentTarget.dataset.id };
        //var removeObject = { removeStakeholdersId: e.currentTarget.attributes['data-id'].value };
        var removeObject = { removeStakeholdersId: id };

        await fetch(global.variables.API_ASSIGNMISSION_STAKEHOLDERS_REMOVE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(removeObject)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadPageStakeholders();
            });

        await this.setState({ isFetching: false });
    }

    handleMONUserRecord = async (e) => {

        await this.setState({ isFetching: true });

        console.log(this.state);
        //console.log("MonUserId: " + this.state.monuserid);

        await fetch(global.variables.API_ASSIGNMISSION_MON, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadPageMONQCQADetails();
            });

        await this.setState({ isFetching: false });
    }

    handleQCUserRecord = async (e) => {

        await this.setState({ isFetching: true });

        console.log(this.state);

        await fetch(global.variables.API_ASSIGNMISSION_QC, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadPageMONQCQADetails();
            });

        await this.setState({ isFetching: false });
    }

    handleQAUserRecord = async (e) => {

        await this.setState({ isFetching: true });

        console.log(this.state);

        await fetch(global.variables.API_ASSIGNMISSION_QA, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadPageMONQCQADetails();
            });

        await this.setState({ isFetching: false });
    }

    handletypeOfROMSelectChange = async (e, v) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ typeOfROM: v.TypeId });
        } else {
            await this.setState({ typeOfROM: -1 });
        }

        console.log(e.target.name + ": " + e.target.value);
        console.log(this.state);
    }

    handleSaveOnClick = async () => {

        await this.setState({ isFetching: true });

        console.log(this.state);

        await fetch(global.variables.API_UPDATEMISSION, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            });

        await this.setState({ isFetching: false });
    }

    handleChangeProject = async () => {

        await this.setState({ isFetching: true });

        //console.log(this.state.selectedcomponentprojectid);
        //console.log(this.state.missionId);
        //console.log(this.state.selectedmissionid);
        console.log(this.state);

        await fetch(global.variables.API_PROJECTDETAILS_CHANGEPROJECTIDOFMISSION, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            });

        await this.setState({ isFetching: false });

    }

    handleResetMissionContent = async () => {
        await this.setState({ isFetching: true });

        //console.log(this.state.selectedcomponentprojectid);
        //console.log(this.state.missionId);
        //console.log(this.state.selectedmissionid);
        console.log(this.state);

        await fetch(global.variables.API_PROJECTDETAILS_RESETMISSIONDETAILS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            });

        await this.setState({ isFetching: false });
    }

    handleProjectSelectChange = async (e, v) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({
                selectedcomponentprojectid: v.idProjectDetails
            });
        } else {
            await this.setState({
                selectedcomponentprojectid: -1
            });
        }

        //console.log(this.state.selectedcomponentprojectid);
    };

    handleDoMissionReset = async () => {
        //console.log(val);
        //var val = this.state.idFileUploadDelete;

        //if (val !== undefined & val !== null & val !== 0) {
        //    await this.setModalDeleteOpenToggle();

        //    await this.handleDeleteFreeFormOnlyFiles(val);

        //    await this.loadFreeFormOnlyFiles();
        //} else {
        //    await this.setModalDeleteOpenToggle();
        //}

        await this.setModalResetOpenToggle();

        await this.handleResetMissionContent();

        window.location.reload();
    }

    handleMissionResetConfirmation = async (val) => {
        //console.log(val);

        //await this.setState({ idFileUploadDelete: val });

        await this.setModalResetOpenToggle();
    }

    setModalResetOpenToggle = async () => {
        //var o = modalDeleteOpen;

        await this.setState({ modalResetOpen: !this.state.modalResetOpen });
        //await this.setState({ modalDeleteOpen: true });
    }

    handleDoChangeProject = async () => {
        await this.setModalChangeProjectToggle();

        await this.handleChangeProject();

        window.location.reload();
    }

    handleChangeProjectConfirmation = async (val) => {
        await this.setModalChangeProjectToggle();
    }

    setModalChangeProjectToggle = async () => {

        await this.setState({ modalChangeProject: !this.state.modalChangeProject });
    }

    loadPageStakeholders = () => {
        fetch(global.variables.API_ASSIGNMISSION_LOADPAGE_STAKEHOLDERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ stakeholders: result.missionstakeholders });
            });
    }

    loadPageUsers = () => {
        let pageData = { operation: "LoadPageUsers" };

        fetch(global.variables.API_ASSIGNMISSION_LOADPAGE_USERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ users: result.listofusers });
            });
    }

    //loadPageProjects = async () => {
    //    let pageData = { operation: "GetListOfProjects" };

    //    await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFPROJECTS, {
    //        method: "POST",
    //        headers: {
    //            Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //            Accept: "application/json",
    //            "Content-Type": "application/json"
    //        },
    //        body: JSON.stringify(pageData)
    //    })
    //        .then(response => response.json())
    //        .then(result => {
    //            console.log(result);

    //            this.setState({ projects: result.projects });
    //        });
    //}

    //loadPageMissions = async () => {
    //    let pageData = {
    //        operation: "GetListOfMisions",
    //        selectedprojectid: this.state.selectedprojectid
    //    };

    //    await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFMISSIONS, {
    //        method: "POST",
    //        headers: {
    //            Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //            Accept: "application/json",
    //            "Content-Type": "application/json"
    //        },
    //        body: JSON.stringify(pageData)
    //    })
    //        .then(response => response.json())
    //        .then(result => {
    //            console.log(result);

    //            this.setState({ missions: result.missions });
    //        });
    //}

    loadPageMONQCQADetails = async () => {
        await fetch(global.variables.API_ASSIGNMISSION_LOADPAGE_MONQCQADETAILS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    this.setState({
                        missionMonitor: result.monuserassigned[0],
                        missionQualityController: result.qcuserassigned[0],
                        missionQualityAssurance: result.qauserassigned[0],
                        reasonfortheRomReview: result.missiondetails[0].ReasonfortheROMReview,
                        fieldPhaseStartDate: result.missiondetails[0].FieldPhaseStartDate,
                        fieldPhaseEndDate: result.missiondetails[0].FieldPhaseEndDate,

                    });

                    if (result.monuserassigned.length > 0) {
                        this.setState({
                            monuserid: result.monuserassigned[0].idLoginCredentials,
                        });
                    }

                    if (result.qcuserassigned.length > 0) {
                        this.setState({
                            qcuserid: result.qcuserassigned[0].idLoginCredentials,
                        });
                    }

                    if (result.qauserassigned.length > 0) {
                        this.setState({
                            qauserid: result.qauserassigned[0].idLoginCredentials,
                        });
                    }
                }
            });
    }

    loadPageTemplateButtons = async () => {

        await fetch(global.variables.API_PROJECTDETAILS_GETTYPEOFROM, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({
                    typeOfROM: result.typeOfROM
                });

                if (result.typeOfROM === 1) {
                    this.setState({
                        mrFile: global.variables.API_FILEUPLOADDOWNLOAD_DOWNLOADTEMPLATEWITHAUTOFILL + "/" + btoa(localStorage.getItem("authtoken")) + "/1/" + this.state.missionId,
                        mqFile: global.variables.API_FILEUPLOADDOWNLOAD_DOWNLOADTEMPLATEWITHAUTOFILL + "/" + btoa(localStorage.getItem("authtoken")) + "/3/" + this.state.missionId,
                        nsFile: null,
                        nwFile: null,
                        mrFileName: this.state.missionId + "MROngoing.docx",
                        mqFileName: this.state.missionId + "MQOngoing.docx",
                        nsFileName: null,
                        nwFileName: null
                    });
                } else if (result.typeOfROM === 2) {
                    this.setState({
                        mrFile: global.variables.API_FILEUPLOADDOWNLOAD_DOWNLOADTEMPLATEWITHAUTOFILL + "/" + btoa(localStorage.getItem("authtoken")) + "/2/" + this.state.missionId,
                        mqFile: global.variables.API_FILEUPLOADDOWNLOAD_DOWNLOADTEMPLATEWITHAUTOFILL + "/" + btoa(localStorage.getItem("authtoken")) + "/4/" + this.state.missionId,
                        nsFile: null,
                        nwFile: null,
                        mrFileName: this.state.missionId + "MRExpost.docx",
                        mqFileName: this.state.missionId + "MQExpost.docx",
                        nsFileName: null,
                        nwFileName: null
                    });
                } else if (result.typeOfROM === 3) {
                    this.setState({
                        mrFile: null,
                        mqFile: null,
                        nsFile: global.variables.API_FILEUPLOADDOWNLOAD_DOWNLOADTEMPLATEWITHAUTOFILL + "/" + btoa(localStorage.getItem("authtoken")) + "/5/" + this.state.missionId,
                        nwFile: null,
                        mrFileName: null,
                        mqFileName: null,
                        nsFileName: this.state.missionId + "NSOngoing.docx",
                        nwFileName: null
                    });
                } else if (result.typeOfROM === 4) {
                    this.setState({
                        mrFile: null,
                        mqFile: null,
                        nsFile: global.variables.API_FILEUPLOADDOWNLOAD_DOWNLOADTEMPLATEWITHAUTOFILL + "/" + btoa(localStorage.getItem("authtoken")) + "/6/" + this.state.missionId,
                        nwFile: null,
                        mrFileName: null,
                        mqFileName: null,
                        nsFileName: this.state.missionId + "NSExpost.docx",
                        nwFileName: null
                    });
                } else if (result.typeOfROM === 5) {
                    this.setState({
                        mrFile: null,
                        mqFile: null,
                        nsFile: null,
                        nwFile: global.variables.API_FILEUPLOADDOWNLOAD_DOWNLOADTEMPLATEWITHAUTOFILL + "/" + btoa(localStorage.getItem("authtoken")) + "/7/" + this.state.missionId,
                        mrFileName: null,
                        mqFileName: null,
                        nsFileName: null,
                        nwFileName: this.state.missionId + "NWOngoing.docx"
                    });
                } else if (result.typeOfROM === 6) {
                    this.setState({
                        mrFile: null,
                        mqFile: null,
                        nsFile: null,
                        nwFile: global.variables.API_FILEUPLOADDOWNLOAD_DOWNLOADTEMPLATEWITHAUTOFILL + "/" + btoa(localStorage.getItem("authtoken")) + "/8/" + this.state.missionId,
                        mrFileName: null,
                        mqFileName: null,
                        nsFileName: null,
                        nwFileName: this.state.missionId + "NWExpost.docx"
                    });
                } else {
                    this.setState({
                        mrFile: null,
                        mqFile: null,
                        nsFile: null,
                        nwFile: null,
                        mrFileName: null,
                        mqFileName: null,
                        nsFileName: null,
                        nwFileName: null
                    });
                }
            });
    }

    loadPageProjects = async () => {
        let pageData = { operation: "GetListOfProjects" };

        await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFALLPROJECTS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ projects: result.projects });
            });
    }

    getUserType = () => {
        let pageData = {
            operation: "GetUserType"
        };

        fetch(global.variables.API_USEROPERATIONS_GETUSERTYPE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ userType: result.userType });
            });
    }

    getUserRole = () => {
        let pageData = {
            operation: "GetUserRole",
            missionId: this.state.missionId
        };

        fetch(global.variables.API_USEROPERATIONS_GETUSERROLE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ userRole: result.userRole });

                //this.setState({ schedulePlan: "/scheduleplan" });
                this.setState({ schedulePlan: global.variables.API_FILEUPLOADDOWNLOAD_DOWNLOADSTATICFILE + "/" + btoa(localStorage.getItem("authtoken")) + "/1" });

                if (result.userRole === 10) { // Disabled by comparing with 10
                    // Monitor

                    //console.log("monitor if");

                    this.setState({
                        monQualityCheckList: "/monqualitychecklist",
                        qcQualityCheckList: null
                    });
                } if (result.userRole === 20) { // Disabled by comparing with 20
                    // QC

                    //console.log("qc if");

                    this.setState({
                        monQualityCheckList: null,
                        qcQualityCheckList: "/qcqualitychecklist"
                    });
                }
                //else {
                //    // Error
                //    //this.setState({ userRole: -1 });

                //    console.log("else if");

                //    this.setState({
                //        monQualityCheckList: null,
                //        qcQualityCheckList: null
                //    });
                //}
            });
    }

    //returnArrayElementUsers = (array, element) => {
    //    for (var i = 0; i < this.state.users.length; i++) {
    //        if (this.state.users[i].idLoginCredentials == element) {
    //            return array[i];
    //        }
    //    }

    //    return (null);
    //};

    render() {

        const {
            missionMonitor,
            missionQualityController,
            missionQualityAssurance,
            stakeholderName,
            stakeholderSurname,
            stakeholderCompany,
            stakeholderEmail,
            stakeholders,
            projects,
            users,
            //monuserid,
            //qcuserid,
            //qauserid,
            //missions,
            typeOfROM,
            reasonfortheRomReview,
            fieldPhaseStartDate,
            fieldPhaseEndDate,
            //missionDetails,
            mrFile,
            mqFile,
            nsFile,
            nwFile,
            mrFileName,
            mqFileName,
            nsFileName,
            nwFileName,
            userType,
            //userRole,
            isFetching,
            isLoadingFinished,
            monQualityCheckList,
            qcQualityCheckList,
            schedulePlan,
            //selectedcomponentprojectid,
            modalResetOpen,
            modalChangeProject,
        } = this.state


        if (!isLoadingFinished) {

            return (
                <CircularProgress />
            );

        } else {

            return (
                <Grid container spacing={3}>
                    <Grid>
                        <ToastContainer />
                    </Grid>
                    <Grid item xs={12} className="mt-1">
                        {
                            //<Button variant="primary" onClick={() => this.setModalDeleteOpen()}>
                            //    Launch demo modal
                            //</Button>
                        }

                        <Modal show={modalResetOpen} onHide={() => this.setModalResetOpenToggle()} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Reset Confirmation</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>Are you sure you want to reset?</Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => this.handleDoMissionReset()}>
                                    Reset
                            </Button>
                                <Button variant="primary" onClick={() => this.setModalResetOpenToggle()}>
                                    Cancel
                            </Button>
                            </Modal.Footer>
                        </Modal>
                    </Grid>

                    <Grid item xs={12} className="mt-1">
                        <Modal show={modalChangeProject} onHide={() => this.setModalChangeProjectToggle()} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Change Project Confirmation</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>Are you sure you want to change project?</Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => this.handleDoChangeProject()}>
                                    Change
                            </Button>
                                <Button variant="primary" onClick={() => this.setModalChangeProjectToggle()}>
                                    Cancel
                            </Button>
                            </Modal.Footer>
                        </Modal>
                    </Grid>

                    <Grid item xs={12} className="mt-2">
                        <DashboardRomTemplates
                            mrFile={mrFile}
                            mqFile={mqFile}
                            nsFile={nsFile}
                            nwFile={nwFile}
                            mrFileName={mrFileName}
                            mqFileName={mqFileName}
                            nsFileName={nsFileName}
                            nwFileName={nwFileName}
                            monQualityCheckList={monQualityCheckList}
                            qcQualityCheckList={qcQualityCheckList}
                            schedulePlan={schedulePlan}
                        />
                    </Grid>

                    {
                        //<Grid item xs={12}>
                        //    <ProjectSelect
                        //        title="Please Select Project Title or Project Number"
                        //        projects={projects}
                        //        onchange={this.handleProjectSelectChange.bind(this)}
                        //    />
                        //</Grid>
                        //<Grid item xs={12} className="mt-1">
                        //    <MissionSelect
                        //        title="Please Select Mission"
                        //        missions={missions}
                        //        onchange={this.handleMissionSelectChange.bind(this)}
                        //    />

                        //</Grid>
                    }


                    <Grid item xs={6} className="mt-1">
                        <RomData
                            onSelectChange={this.handleSelectChange}
                            onChangetypeOfROM={this.handletypeOfROMSelectChange}
                            typeOfROM={typeOfROM}
                            userType={userType}
                        />
                    </Grid>
                    <Grid item xs={6} className="mt-1">
                        <RomReview
                            onChangeDate={(name, value) =>
                                this.handleChangeDate(name, value)
                            }
                            onChange={this.handleChange}
                            reasonfortheRomReview={reasonfortheRomReview}
                            //romExpertName={romExpertName}
                            //coMonitor={coMonitor}
                            fieldPhaseStartDate={fieldPhaseStartDate}
                            fieldPhaseEndDate={fieldPhaseEndDate}
                            userType={userType}
                        />
                    </Grid>


                    <Grid item xs={12} className="mt-1">
                        <Card>
                            <CardHeader title="Mission Monitor" className="romis-card-header"></CardHeader>
                            <CardContent>
                                <Grid container spacing={2}>

                                    <Grid item xs={10}>

                                        {
                                            //<TextField
                                            //    fullWidth
                                            //    placeholder="E-Mail"
                                            //    margin="normal"
                                            //    onChange={this.handleChange.bind(this)}
                                            //    value={projectMonitor}
                                            //    name="projectMonitor"
                                            ///>
                                        }

                                        <Autocomplete
                                            options={users}
                                            //getOptionLabel={option => option.LoginUsername + " " + option.LoginEmail + " " + option.LoginName + " " + option.LoginSurname}
                                            getOptionLabel={option => option.LoginName + " " + option.LoginSurname}
                                            autoComplete
                                            includeInputInList
                                            onChange={this.handleMONUserChange.bind(this)}
                                            renderInput={params => (
                                                <TextField {...params} label="Monitor" margin="normal" fullWidth />
                                            )}
                                            value={missionMonitor}
                                            disabled={userType === 2 ? false : true}
                                        />

                                    </Grid>
                                    <Grid item xs={2} style={{ display: userType === 2 ? "block" : "none" }} >
                                        <Button variant="contained" color="primary" className="mt"
                                            onClick={this.handleMONUserRecord.bind(this)}
                                            disabled={isFetching ? true : false}
                                        //style={{ display: userType === 2 ? "block" : "none" }}
                                        >
                                            Confirm & Add
                                    </Button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} className="mt-1">
                        <Card>
                            <CardHeader title="Mission Quality Controller" className="romis-card-header"></CardHeader>
                            <CardContent>
                                <Grid container spacing={2}>

                                    <Grid item xs={10}>

                                        {
                                            //<TextField
                                            //    fullWidth
                                            //    placeholder="E-Mail"
                                            //    margin="normal"
                                            //    onChange={this.handleChange.bind(this)}
                                            //    value={projectQualityController}
                                            //    name="projectQualityController"

                                            ///>
                                        }

                                        <Autocomplete
                                            options={users}
                                            //getOptionLabel={option => option.LoginUsername + " " + option.LoginEmail + " " + option.LoginName + " " + option.LoginSurname}
                                            getOptionLabel={option => option.LoginName + " " + option.LoginSurname}
                                            autoComplete
                                            includeInputInList
                                            onChange={this.handleQCUserChange.bind(this)}
                                            renderInput={params => (
                                                <TextField {...params} label="Quality Controller" margin="normal" fullWidth />
                                            )}
                                            value={missionQualityController}
                                            disabled={userType === 2 ? false : true}
                                        />
                                    </Grid>
                                    <Grid item xs={2} style={{ display: userType === 2 ? "block" : "none" }} >
                                        <Button variant="contained" color="primary" className="mt"
                                            onClick={this.handleQCUserRecord.bind(this)} disabled={isFetching ? true : false}>Confirm & Add</Button>
                                    </Grid>
                                </Grid>


                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} className="mt-1">
                        <Card>
                            <CardHeader title="Mission Quality Assurance Expert" className="romis-card-header"></CardHeader>
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={10}>
                                        <Autocomplete
                                            options={users}
                                            //getOptionLabel={option => option.LoginUsername + " " + option.LoginEmail + " " + option.LoginName + " " + option.LoginSurname}
                                            getOptionLabel={option => option.LoginName + " " + option.LoginSurname}
                                            autoComplete
                                            includeInputInList
                                            onChange={this.handleQAUserChange.bind(this)}
                                            renderInput={params => (
                                                <TextField {...params} label="Quality Assurance Expert" margin="normal" fullWidth />
                                            )}
                                            value={missionQualityAssurance}
                                            disabled={userType === 2 ? false : true}
                                        />
                                    </Grid>
                                    <Grid item xs={2} style={{ display: userType === 2 ? "block" : "none" }} >
                                        <Button variant="contained" color="primary" className="mt"
                                            onClick={this.handleQAUserRecord.bind(this)} disabled={isFetching ? true : false} >Confirm & Add</Button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} className="mt-1">
                        <Card>
                            <CardHeader title="Stakeholders" className="romis-card-header"></CardHeader>
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={3}>
                                        <TextField
                                            placeholder="Name"
                                            fullWidth
                                            margin="normal"
                                            onChange={this.handleChange.bind(this)}
                                            value={stakeholderName}
                                            name="stakeholderName"
                                            disabled={userType === 2 ? false : true}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            placeholder="Surname"
                                            fullWidth
                                            margin="normal"
                                            onChange={this.handleChange.bind(this)}
                                            value={stakeholderSurname}
                                            name="stakeholderSurname"
                                            disabled={userType === 2 ? false : true}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            fullWidth
                                            placeholder="Company&Instutition"
                                            margin="normal"
                                            onChange={this.handleChange.bind(this)}
                                            value={stakeholderCompany}
                                            name="stakeholderCompany"
                                            disabled={userType === 2 ? false : true}
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <TextField
                                            fullWidth
                                            placeholder="E-Mail"
                                            margin="normal"
                                            onChange={this.handleChange.bind(this)}
                                            value={stakeholderEmail}
                                            name="stakeholderEmail"
                                            disabled={userType === 2 ? false : true}
                                        />
                                    </Grid>
                                    <Grid item xs={1} style={{ display: userType === 2 ? "block" : "none" }} >
                                        <Button variant="contained" color="primary" className="mt"
                                            onClick={this.handleAddStakeholdersOnClick.bind(this)} disabled={isFetching ? true : false}>Add</Button>
                                    </Grid>
                                </Grid>
                                <Table aria-label="simple table" className="mt-1">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Name </TableCell>
                                            <TableCell align="right">Surname </TableCell>
                                            <TableCell align="right">Company&Instutition</TableCell>
                                            <TableCell align="right">E-Mail</TableCell>
                                            <TableCell align="right" style={{
                                                display: userType === 2 ? "block" : "none"
                                            }} >Options</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {stakeholders.map(({ idMissionStakeholders, stakeholderName, stakeholderSurname, stakeholderCompany, stakeholderEmail }, index) => {
                                            return (
                                                <TableRow key={idMissionStakeholders}>
                                                    <TableCell component="th" scope="row">{stakeholderName} </TableCell>
                                                    <TableCell align="right">{stakeholderSurname}</TableCell>
                                                    <TableCell align="right">{stakeholderCompany}</TableCell>
                                                    <TableCell align="right">{stakeholderEmail}</TableCell>
                                                    <TableCell align="right" style={{
                                                        display: userType === 2 ? "block" : "none"
                                                    }}>
                                                        <Button variant="outlined" color="secondary"
                                                            data-id={idMissionStakeholders}
                                                            //onClick={this.handleRemoveStakeholdersOnClick.bind(this)}
                                                            onClick={() => { this.handleRemoveStakeholdersOnClick(idMissionStakeholders) }}
                                                        >
                                                            Remove
                 									 </Button>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} className="mt-1" style={{ display: userType === 2 ? "block" : "none" }} >
                        <Button variant="contained" color="primary" onClick={this.handleSaveOnClick.bind(this)} disabled={isFetching ? true : false}>
                            UPDATE
                    </Button>
                    </Grid>


                    <Grid item xs={12} className="mt-1" style={{ display: userType === 2 ? "block" : "none" }} >
                        <Card>
                            <CardHeader title="Supervisor Access" className="romis-card-header"></CardHeader>
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={10}>
                                        <Autocomplete
                                            options={projects}
                                            getOptionLabel={option => option.ProjectTitle}
                                            autoComplete
                                            includeInputInList
                                            onChange={this.handleProjectSelectChange.bind(this)}
                                            renderInput={params => (
                                                <TextField {...params} label="Projects" margin="normal" fullWidth />
                                            )}
                                        />
                                        {
                                            //<Autocomplete
                                            //    options={users}
                                            //    //getOptionLabel={option => option.LoginUsername + " " + option.LoginEmail + " " + option.LoginName + " " + option.LoginSurname}
                                            //    getOptionLabel={option => option.LoginName + " " + option.LoginSurname}
                                            //    autoComplete
                                            //    includeInputInList
                                            //    onChange={this.handleQAUserChange.bind(this)}
                                            //    renderInput={params => (
                                            //        <TextField {...params} label="Quality Assurance" margin="normal" fullWidth />
                                            //    )}
                                            //    value={missionQualityAssurance}
                                            //    disabled={userType === 2 ? false : true}
                                            ///>
                                        }
                                    </Grid>
                                    <Grid item xs={2} >
                                        <Button variant="contained" color="primary" className="mt"
                                            onClick={this.handleChangeProjectConfirmation.bind(this)} disabled={isFetching ? true : false} >Change Project</Button>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button variant="contained" color="primary" className="mt"
                                        onClick={this.handleMissionResetConfirmation.bind(this)} disabled={isFetching ? true : false}
                                        style={{ width: "100%" }}>Reset Mission Content</Button>
                                </Grid>

                            </CardContent>
                        </Card>
                    </Grid>

                </Grid >
            );
        }
    }
}




// WEBPACK FOOTER //
// ./src/pages/MissionDetailsPage.js